/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Fragment, useEffect, useRef, useState } from 'react';
import plus from '../images/plus_color.svg';
import 'react-quill/dist/quill.snow.css';
import TrueAndFalse from './TureAndFalse';
import OrderListQuestions from './OrderListQuestions';
import MatchingColumnOption from './MatchingColumnOption';
import MultiSelectOption from './MultiSelectOption';
import { useSelector } from 'react-redux';
import AddOptions from './activity/addOptions';
import FillTheBlanks from './FillTheBlanks';
import FreeResponse from './FreeResponse';
import MultiChoice from './MultiChoice';
import ActivityMedia from './ActivityMedia';

const Question = ({
  question,
  setDifficulty,
  activityScore,
  index,
  editQuestion,
  types,
  removeQuestion,
  setNewActivities,
  actIndex,
  setEditing,
  handleQuestionLevelMedia = () => {},
}) => {
  const [value, setValue] = useState('');
  const [isEditing, setIsEditing] = useState(true);
  const [isMore, setIsMore] = useState(true);
  const [selectedOption, setSelectedOption] = useState('text');
  const { user } = useSelector((state) => state.auth);
  const [isTotalBlanks, setIsTotalBlanks] = useState(0);
  const removeHtmlTags = (text) => text.replace(/<\/?[^>]+>/gi, '');
  const [questionss, setQuestionss] = useState([
    {
      type: 'orderlist',
      options: [],
    },
  ]);

  const [questionMatching, setQuestionMatching] = useState([
    {
      type: 'matching',
      leftOptions: [],
      rightOptions: [],
    },
  ]);
  const [questionMuliSelect, setQuestionMultiSelect] = useState([
    {
      type: 'multi select',
      options: [],
    },
  ]);
  const [optionTypes, setOptionTypes] = useState(['text', 'image', 'audio', 'video']);
  const [openMedia, setOpenMedia] = useState(false);
  const [mediaList, setMediaList] = useState([]);

  const elRef = useRef(null);
  const handleMediaUpload = (fileUrl, mediaIndex, fileType = 'image') => {
    setMediaList((prev) =>
      prev.map((item, i) => (i === mediaIndex ? { ...item, url: fileUrl } : item))
    );

    handleQuestionLevelMedia(fileUrl, index, mediaIndex, fileType);
  };
  const setDesc = (e) => {
    setNewActivities((old) =>
      old.map((activity, actIdx) =>
        actIdx !== actIndex
          ? activity
          : {
              ...activity,
              questions: activity.questions.map((q, qIdx) =>
                qIdx !== index
                  ? q
                  : {
                      ...q,
                      description: e.target.value,
                    }
              ),
            }
      )
    );
  };

  useEffect(() => {
    const handleClick = (event) => {
      if (elRef.current && !elRef.current.contains(event.target)) {
        // Clicked outside of the wrapperRef
        setOpenMedia(false);
      }
    };

    // Attach the event listener to the body when the component mounts
    document.body.addEventListener('click', handleClick);

    // Clean up the event listener when the component unmounts
    return () => {
      document.body.removeEventListener('click', handleClick);
    };
  }, []);
  const getAlphabeticalOrder = (index) => {
    const alphabet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
    return alphabet[index] || '';
  };
  const addOption = (optionType) => {
    setNewActivities((oldActs) =>
      oldActs.map((a, ai) =>
        ai !== actIndex
          ? a
          : {
              ...a,
              questions: a.questions.map((q, qi) =>
                qi !== index
                  ? q
                  : {
                      ...q,
                      options: [
                        ...q.options,
                        {
                          type: optionType ? optionType : q?.options?.[0]?.type || 'text',
                          text: '',
                        },
                      ],
                    }
              ),
            }
      )
    );
  };
  const addBlankOption = (newIndexNo, range, text) => {
    setNewActivities((oldActs) =>
      oldActs.map((a, ai) =>
        ai !== actIndex
          ? a
          : {
              ...a,
              questions: a.questions.map((q, qi) =>
                qi !== index
                  ? q
                  : {
                      ...q,
                      blanksBank: q.blanksBank.some((e) => e.position === range.index)
                        ? q.blanksBank.filter((e) => e.position !== range.index)
                        : [
                            ...q.blanksBank,
                            {
                              indexNo: newIndexNo, // Assign a unique indexNo for each occurrence
                              position: range.index, // Store the unique position
                              answers: [text], // Store the answer text
                            },
                          ],
                    }
              ),
            }
      )
    );
    // setQuestions((old) =>
    //   old.map((q, i) => {
    //     if (i !== index) {
    //       return q;
    //     } else {
    //       return {
    //         ...q,
    //         blanksBank: q.blanksBank.some((e) => e.position === range.index)
    //           ? q.blanksBank.filter((e) => e.position !== range.index)
    //           : [
    //               ...q.blanksBank,
    //               {
    //                 indexNo: newIndexNo, // Assign a unique indexNo for each occurrence
    //                 position: range.index, // Store the unique position
    //                 answers: [text] // Store the answer text
    //               }
    //             ]
    //       };
    //     }
    //   })
    // );
  };
  const handleAlternateAnswer = (indexNo, value) => {
    setNewActivities((oldActs) =>
      oldActs.map((a, ai) =>
        ai !== actIndex
          ? a
          : {
              ...a,
              questions: a.questions.map((q, qi) =>
                qi !== index
                  ? q
                  : {
                      ...q,
                      blanksBank: q.blanksBank.map((item) =>
                        item.indexNo === indexNo
                          ? {
                              ...item,
                              answers: value.split(',').map((ans) => ans.trim().toLowerCase()),
                            }
                          : item
                      ),
                    }
              ),
            }
      )
    );
  };
  const handleBlankInput = (HTML) => {
    setNewActivities((oldActs) =>
      oldActs.map((a, ai) =>
        ai !== actIndex
          ? a
          : {
              ...a,
              questions: a.questions.map((q, qi) =>
                qi !== index
                  ? q
                  : {
                      ...q,
                      sentence: HTML,
                    }
              ),
            }
      )
    );

    const textWithoutHtml = removeHtmlTags(HTML);

    // Check if HTML content is empty
    if (!textWithoutHtml) {
      setNewActivities((oldActs) =>
        oldActs.map((a, ai) =>
          ai !== actIndex
            ? a
            : {
                ...a,
                questions: a.questions.map((q, qi) =>
                  qi !== index ? q : { ...q, bankQuestion: [], blanksBank: [] }
                ),
              }
        )
      );
    } else {
      const wordsArray = textWithoutHtml
        .toLowerCase()
        .replace(/\./g, '')
        .replace(/,/, '')
        .split(' ');
      setNewActivities((oldActs) =>
        oldActs.map((a, ai) =>
          ai !== actIndex
            ? a
            : {
                ...a,
                questions: a.questions.map((q, qi) =>
                  qi !== index ? q : { ...q, bankQuestion: wordsArray }
                ),
              }
        )
      );
    }
  };
  const autoResize = (e) => {
    e.target.style.height = '22px'; // Reset the height initially
    e.target.style.height = `${e.target.scrollHeight}px`; // Adjust height based on content
  };

  return (
    <div className='Multiple_choice_wrap  option_matching' style={{ background: '#FFF' }}>
      <div className='edit-act-question-top-nav mb-0'>
        <h5>{types[question.type]}</h5>
        <ul>
          <li>
            <a
              className='edit-activity-question-delete cursor'
              onClick={() => removeQuestion(index)}
            >
              delete
            </a>
          </li>
          <li>
            <a className='edit-activity-question-edit cursor' onClick={() => setIsEditing(true)}>
              {isEditing || question.isNew ? 'editing' : 'edit'}
            </a>
          </li>
        </ul>
      </div>

      <div className='Multiple_choice_body'>
        <textarea
          type='text'
          style={{ height: '22px', display: 'flex' }}
          className='questioninput'
          placeholder={`${
            question.type === 'blanks' ? 'Add title or description' : 'Write a question'
          }`}
          name='text'
          onChange={(e) => {
            editQuestion(e, index);
            autoResize(e); // Adjust the height dynamically
          }}
          value={question.text}
          disabled={!isEditing}
          ref={(el) => (el ? autoResize({ target: el }) : null)} // Automatically adjust the height on mount
        />

        {isEditing ? (
          <Fragment>
            {/* <div className='description-input-wrapper'>
              <img src={plus} alt='plus' style={{ display: 'flex', alignSelf: 'flex-start' }} />
              <textarea
                style={{ resize: 'none' }}
                className='activity-description-input'
                placeholder='Write instructions or use plus for media (optional)'
                name='description'
                onChange={(e) => {
                  editQuestion(e, index);
                  autoResize(e);
                }}
                ref={(el) => (el ? autoResize({ target: el }) : null)}
                value={question.description}
              />
            </div> */}
            <ActivityMedia
              handleMediaUpload={handleMediaUpload}
              setOpenMedia={setOpenMedia}
              setMediaList={setMediaList}
              openMedia={openMedia}
              mediaList={mediaList}
              activity={question?.description}
              setDesc={setDesc}
              elRef={elRef}
            />
            <div className='edit-act-question-top-nav'>
              <div
                style={{
                  display: 'flex',
                  width: '32.5%',
                  justifyContent: 'space-between',
                }}
              >
                <span className='points-label'>
                  {Math.round((question.score / activityScore) * 100)}%
                </span>
                <div
                  style={{
                    display: 'flex',
                    width: '67%',
                    justifyContent: 'space-between',
                  }}
                >
                  <div
                    onClick={() => {
                      setDifficulty(index, 1);
                    }}
                    style={{
                      width: '30px',
                      height: '15px',
                      borderRadius: '6px 0px 0px 6px',
                      border: '0.5px solid var(--Grey-700, #76736F)',
                      cursor: 'pointer',
                      background: `${
                        question.difficulty === 1
                          ? '#0A5C59'
                          : question.difficulty === 2
                          ? '#FFBF00'
                          : '#AE2604'
                      }`,
                    }}
                  ></div>
                  <div
                    onClick={() => {
                      setDifficulty(index, 2);
                    }}
                    style={{
                      width: '30px',
                      height: '15px',
                      border: '0.5px solid var(--Grey-700, #76736F)',
                      cursor: 'pointer',
                      background: `${
                        question.difficulty === 2
                          ? '#FFBF00'
                          : question.difficulty === 3
                          ? '#AE2604'
                          : '#D2CFCB'
                      }`,
                    }}
                  ></div>
                  <div
                    onClick={() => {
                      setDifficulty(index, 3);
                    }}
                    style={{
                      width: '30px',
                      height: '15px',
                      borderRadius: '0px 6px 6px 0px',
                      border: '0.5px solid var(--Grey-700, #76736F)',
                      cursor: 'pointer',
                      background: `${question.difficulty === 3 ? '#AE2604' : '#D2CFCB'}`,
                    }}
                  ></div>
                </div>
              </div>

              <ul>
                <li>
                  <a
                    className='edit-activity-question-view-more cursor'
                    onClick={() => setIsMore((old) => !old)}
                  >
                    {isMore ? 'hide answers' : 'show answers'}
                  </a>
                </li>
              </ul>
            </div>
          </Fragment>
        ) : (
          <Fragment>
            <ActivityMedia
              handleMediaUpload={handleMediaUpload}
              setOpenMedia={setOpenMedia}
              setMediaList={setMediaList}
              openMedia={openMedia}
              mediaList={mediaList}
              activity={question?.description}
              setDesc={setDesc}
              elRef={elRef}
              mode='save'
            />
            <div className='edit-act-question-top-nav '>
              <span className='points_answer'>
                <b>{Math.round((question.score / activityScore) * 100)} % </b>{' '}
                {question.type === 'fr' || question.type === 'sa' ? (
                  ''
                ) : (
                  <span style={{ fontSize: '22px' }}>| </span>
                )}
                {question.type === 'fr' || question.type === 'sa'
                  ? ''
                  : question.type === 'blanks'
                  ? question.blanksBank.length
                  : question.options.length}{' '}
                {question.type === 'blanks'
                  ? 'blanks'
                  : ['mcqs', 'truefalse'].includes(question.type)
                  ? 'answers'
                  : ''}
                <div
                  style={{
                    height: '10px',
                    width: '30px',
                    display: 'inline-block',
                    marginLeft: '12px',
                    borderRadius: '15px',
                    background: `${
                      question.difficulty === 1
                        ? '#0A5C59'
                        : question.difficulty === 2
                        ? '#FFBF00'
                        : '#AE2604'
                    }`,
                  }}
                ></div>
              </span>

              <ul>
                <li>
                  <a
                    className='edit-activity-question-view-more cursor'
                    onClick={() => setIsMore((old) => !old)}
                  >
                    {isMore ? 'hide answers' : 'show answers'}
                  </a>
                </li>
              </ul>
            </div>
          </Fragment>
        )}
        {isMore && (
          <div className='input_choice '>
            {question.type === 'mcqs' && (
              <MultiChoice
                question={question}
                index={index}
                actIndex={actIndex}
                isEditing={isEditing}
                isMore={isMore}
                setNewActivities={setNewActivities}
              />
            )}
            {['truefalse'].includes(question.type) && (
              <MultiChoice
                question={question}
                index={index}
                actIndex={actIndex}
                isEditing={isEditing}
                isMore={isMore}
                setNewActivities={setNewActivities}
              />
            )}

            {questionss && ['orderlist'].includes(question.type) && (
              <Fragment>
                <OrderListQuestions
                  questionss={questionss}
                  index={index}
                  setQuestionss={setQuestionss}
                  isEditing={isEditing}
                  isMore={isMore}
                />
              </Fragment>
            )}

            {questionMatching && ['matching'].includes(question.type) && (
              <MatchingColumnOption
                isEditing={isEditing}
                isMore={isMore}
                index={index}
                questionMatching={questionMatching}
                setQuestionMatching={setQuestionMatching}
              />
            )}
            {questionMuliSelect && ['multiselect'].includes(question.type) && (
              <MultiSelectOption
                isEditing={isEditing}
                isMore={isMore}
                index={index}
                questionMuliSelect={questionMuliSelect}
                setQuestionMultiSelect={setQuestionMultiSelect}
              />
            )}
            {['blanks'].includes(question.type) && (
              <Fragment>
                <FillTheBlanks
                  setIsEditing={setIsEditing}
                  isEditing={isEditing}
                  question={question}
                  handleAlternateAnswer={handleAlternateAnswer}
                  addBlankOption={addBlankOption}
                  handleBlankInput={handleBlankInput}
                  setIsTotalBlanks={setIsTotalBlanks}
                />
              </Fragment>
            )}
            {['fr', 'sa'].includes(question.type) && (
              <FreeResponse
                setIsEditing={setIsEditing}
                isEditing={isEditing}
                index={index}
                isMore={isMore}
                question={question}
                setIsTotalBlanks={setIsTotalBlanks}
              />
            )}
            {['truefalse'].includes(question.type) ? (
              <Fragment>
                {isEditing && (
                  <div className='option-adder-wrapper mrt-12'>
                    <div className='Multiplechoice_wrap add_text_save'>
                      <div className='btn-group' style={{ alignItems: 'center' }}></div>
                      <div style={{ cursor: 'pointer' }} onClick={() => setIsEditing(false)}>
                        Save --{'>'}
                      </div>
                    </div>
                  </div>
                )}
              </Fragment>
            ) : (
              ''
            )}
            {['orderlist', 'mcqs', 'matching', 'multiselect'].includes(question.type) && (
              <Fragment>
                {isEditing && (
                  <AddOptions
                    selectedOption={selectedOption}
                    optionTypes={optionTypes}
                    setSelectedOption={setSelectedOption}
                    setQuestionss={setQuestionss}
                    getAlphabeticalOrder={getAlphabeticalOrder}
                    questionMatching={questionMatching}
                    setQuestionMatching={setQuestionMatching}
                    setQuestionMultiSelect={setQuestionMultiSelect}
                    setOptionTypes={setOptionTypes}
                    index={index}
                    type={question.type}
                    addOption={addOption}
                    setIsEditing={setIsEditing}
                  />
                )}
              </Fragment>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default Question;
